import * as React from "react";

function SvgMediaAlpha(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 90 80"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <g fill="#f04a22">
        <path d="M78.44,67.32c-2.01,1.23-4.64.61-5.88-1.4,0-.08-5.78-9-13.19-18.08,1.8-2.31,3.47-4.73,5-7.22,5.54,6.64,10.71,13.6,15.47,20.82,1.23,2.01.61,4.64-1.4,5.88" />
        <path d="M65.56,29.59h0c1.24-2.45,2.81-6.25,3.77-8.57,2.1-5.11-6-8.33-7.94-3.15-3.5,8.92-8.11,17.37-13.73,25.13-7.49,11.6-27.55,25.76-35.88,7.89-4.28-8.62-4-21.1.69-27.25,9.54-10.45,25.46,2.9,35.62,12,1.57-2.48,3-5.05,4.28-7.69C-4.09-25-16.75,64.42,23.47,68c13.14-.13,23.53-10,30.99-19.88,4.26-5.82,7.98-12.03,11.1-18.53" />
        <circle cx="71.37" cy="4.47" r="4.47" />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgMediaAlpha);
